import { createRequestConstantNames } from 'store/util/createConstants';
import cc from 'store/util/createReduxConstant';

export const [QUERY_IQS, QUERY_IQS_SUCCESS, QUERY_IQS_FAIL] = createRequestConstantNames(
  cc('QUERY_IQS')
);
